import { createSelector, createSelectorCreator, defaultMemoize } from "reselect";
import type { BetslipApplicationState } from "../BetslipApplicationState";
import type { OpportunitiesState, OpportunityState } from "./opportunities.types";

type BetSelection = {
  urn: string;
};

const NO_OPPORTUNITIES: OpportunitiesState = {};

function hasBetSelectionsChanged(prev: BetSelection[], next: BetSelection[]): boolean {
  return prev.length === next.length && prev.every((selection, i) => selection.urn === next[i].urn);
}

const createGetBetSelectionsSelector = () =>
  createSelectorCreator(defaultMemoize, hasBetSelectionsChanged)(
    (betSelections: BetSelection[]): BetSelection[] => betSelections,
    (betSelections) => betSelections,
  );

export const createGetCombinationOpportunity = () => {
  const getBetSelections = createGetBetSelectionsSelector();

  return createSelector(
    [
      (state: BetslipApplicationState): OpportunitiesState => state.betslipOpportunities ?? NO_OPPORTUNITIES,
      (_: BetslipApplicationState, betSelections: BetSelection[]): BetSelection[] => getBetSelections(betSelections),
    ],
    (opportunitiesState, betSelections): OpportunityState | undefined =>
      Object.values(opportunitiesState).find(({ selections: opportunitySelections }) => {
        if (opportunitySelections.length !== betSelections.length) {
          return false;
        }

        return betSelections.every((selection) =>
          opportunitySelections.some(({ runnerUrn }) => runnerUrn === selection.urn),
        );
      }),
  );
};
